import { render, staticRenderFns } from "./AskModal.vue?vue&type=template&id=905fd058&scoped=true&"
import script from "./AskModal.vue?vue&type=script&lang=ts&"
export * from "./AskModal.vue?vue&type=script&lang=ts&"
import style0 from "./AskModal.vue?vue&type=style&index=0&id=905fd058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905fd058",
  null
  
)

export default component.exports